import styles from "../../../styles/Components/new-insight/signals-section/InsightSignalOperations.module.css";
import { Button } from "antd";
import StrategyDropdown from "./StrategyDropdown";
import React, { useEffect, useState } from "react";
import CreateStrategyModal from "../create-strategy/CreateStrategyModal";
import { useDispatch, useSelector } from "react-redux";
import {
  getStrategySignal,
  getSystemStrategies,
  getUserStrategies,
  seedMarketSystemStrategies,
  setInsightMarketType,
} from "../../../redux/new-insight/actions";
import { pickMarketSystemStrategy } from "./CurrentStrategyInfo";
import { LuRefreshCcw } from "react-icons/lu";
import { useSearchParams } from "react-router-dom";
import { FaBolt, FaLayerGroup, FaPlus } from "react-icons/fa";
import { isStockBoard } from "../../../shared/stockBoards";
import { LIVE_AI_ITEMS, normalizeLiveTimeframe, setLiveAiTimeframe } from "../../../redux/live-suggestion/liveSuggestionSlice";
import { FaListCheck } from "react-icons/fa6";
import ActionButtonsContainer from "../../../ui/ActionButtonsContainer";
import ActionButtonsWrapper from "../../../ui/ActionButtonsWrapper";
import ActionButton from "../../../ui/ActionButton";
import MarketTypePicker from "../../../shared/MarketTypePicker";
import pickerStyles from "../../../styles/shared/MarketTypePicker.module.css";

function InsightSignalOperations() {
  const {
    main: { userData },
    newInsightState: {
      userStrategies,
      userStrategiesStatus,
      systemStrategies,
      systemStrategiesStatus,
      isUserStrategiesFetched,
      isSystemStrategiesFetched,
      signalStatus,
      currentStrategy,
      insightMarketType,
      initialDataFetched,
      getInitialDataLoading,
    },
    liveSuggestion: { liveTimeframe },
  } = useSelector((state) => state);

  const [showCreateStrategyModal, setShowCreateStrategyModal] = useState(false);
  const [searchParams] = useSearchParams();
  const strategy = searchParams.get("strategy") || currentStrategy?.createdDate;

  const dispatch = useDispatch();
  const stockBoard = isStockBoard(insightMarketType);

  const handleRefresh = () => {
    if (signalStatus === "loading") return;
    const market = insightMarketType || "crypto";
    const selected = [...systemStrategies, ...userStrategies].find(
      (item) =>
        item?.createdDate === strategy &&
        (item.market_type || "crypto") === market,
    );
    const pack = selected || pickMarketSystemStrategy(systemStrategies, market);
    if (!pack?.createdDate) return;
    dispatch(
      getStrategySignal(
        userData["custom:custom_username"],
        userData?.email,
        pack.createdDate,
        pack.user_info === "system",
        false,
        market,
      ),
    );
  };

  useEffect(() => {
    if (isStockBoard(insightMarketType)) return;
    if (
      userData?.email &&
      userStrategiesStatus !== "loading" &&
      userStrategiesStatus !== "error" &&
      !isUserStrategiesFetched
    ) {
      dispatch(
        getUserStrategies(
          userData["custom:custom_username"],
          userData?.email,
          insightMarketType || "crypto",
        ),
      );
    }
  }, [
    dispatch,
    insightMarketType,
    isUserStrategiesFetched,
    userData,
    userData?.email,
    userStrategiesStatus,
  ]);

  useEffect(() => {
    const market = insightMarketType || "crypto";
    if (market !== "crypto" && market !== "forex") dispatch(setInsightMarketType("crypto"));
  }, [dispatch, insightMarketType]);

  useEffect(() => {
    if (isStockBoard(insightMarketType)) return;
    if (
      userData?.email &&
      systemStrategiesStatus !== "loading" &&
      systemStrategiesStatus !== "error" &&
      !isSystemStrategiesFetched
    ) {
      dispatch(
        getSystemStrategies(
          userData["custom:custom_username"],
          userData?.email,
          insightMarketType || "crypto",
        ),
      );
    }
  }, [
    dispatch,
    insightMarketType,
    isSystemStrategiesFetched,
    systemStrategiesStatus,
    userData,
    userData?.email,
  ]);

  useEffect(() => {
    const market = insightMarketType || "crypto";
    if (!userData?.email) return;
    if (!isSystemStrategiesFetched || !initialDataFetched) return;
    if (systemStrategiesStatus === "loading" || getInitialDataLoading) return;
    dispatch(
      seedMarketSystemStrategies(
        userData["custom:custom_username"],
        userData.email,
      ),
    );
  }, [
    dispatch,
    getInitialDataLoading,
    initialDataFetched,
    insightMarketType,
    isSystemStrategiesFetched,
    systemStrategies,
    systemStrategiesStatus,
    userData,
  ]);

  return (
    <>
      {/*<ActionButtonsContainer>*/}
      {/*  <li>*/}
      {/*    <Button*/}
      {/*      className={styles.featuresBtn}*/}
      {/*      onClick={() => setShowCreateStrategyModal(true)}*/}
      {/*    >*/}
      {/*      <FaPlus />*/}
      {/*      Create*/}
      {/*    </Button>*/}
      {/*  </li>*/}

      {/*  <li>*/}
      {/*    <StrategyDropdown*/}
      {/*      data={userStrategies}*/}
      {/*      title="Manage"*/}
      {/*      icon={<FaListCheck color="#2a86ff" />}*/}
      {/*      loading={userStrategiesStatus === "loading"}*/}
      {/*      type="user"*/}
      {/*    />*/}
      {/*  </li>*/}

      {/*  <li>*/}
      {/*    <StrategyDropdown*/}
      {/*      data={systemStrategies}*/}
      {/*      title="Templates"*/}
      {/*      icon={<FaLayerGroup color="#2a86ff" />}*/}
      {/*      loading={systemStrategiesStatus === "loading"}*/}
      {/*      type="system"*/}
      {/*    />*/}
      {/*  </li>*/}

      {/*  <li>*/}
      {/*    <Button*/}
      {/*      loading={signalStatus === "loading"}*/}
      {/*      onClick={handleRefresh}*/}
      {/*      className={styles.refreshBtn}*/}
      {/*    >*/}
      {/*      {signalStatus !== "loading" && <LuRefreshCcw />} Refresh*/}
      {/*    </Button>*/}
      {/*  </li>*/}

      {/*{showCreateStrategyModal && (*/}
      {/*  <CreateStrategyModal*/}
      {/*    show={showCreateStrategyModal}*/}
      {/*    closeHandler={() => setShowCreateStrategyModal(false)}*/}
      {/*    type={"create"}*/}
      {/*  />*/}
      {/*)}*/}
      {/*</ActionButtonsContainer>*/}
      <div className={pickerStyles.desktopOnly}>
        <MarketTypePicker
          layout="inline"
          allowedMarkets={["crypto", "forex"]}
          value={insightMarketType || "crypto"}
          onChange={(key) => dispatch(setInsightMarketType(key))}
        />
      </div>
      <ActionButtonsWrapper style={{ width: "fit-content", marginBottom: 0 }}>
        <MarketTypePicker
          className={pickerStyles.mobileOnly}
          allowedMarkets={["crypto", "forex"]}
          value={insightMarketType || "crypto"}
          onChange={(key) => dispatch(setInsightMarketType(key))}
        />
        {(insightMarketType || "crypto") === "crypto" && (
          <ActionButton
            icon={<FaBolt />}
            label="Pivot"
            value={normalizeLiveTimeframe(liveTimeframe)}
            dropdownOptions={{
              items: LIVE_AI_ITEMS,
              onClick: (event) => dispatch(setLiveAiTimeframe(event.key)),
              selectedKeys: [normalizeLiveTimeframe(liveTimeframe)],
            }}
          />
        )}
        {stockBoard && (
          <ActionButton icon={<FaBolt />} label="Pivot" value="1d" />
        )}
        {!stockBoard && (
          <>
            <ActionButton
              onClick={() => setShowCreateStrategyModal(true)}
              icon={<FaPlus />}
              label="Create"
            />
            <li>
              <StrategyDropdown
                data={userStrategies}
                title="Manage"
                icon={<FaListCheck />}
                loading={userStrategiesStatus === "loading"}
                type="user"
              />
            </li>
            <li>
              <StrategyDropdown
                data={systemStrategies}
                title="Templates"
                icon={<FaLayerGroup />}
                loading={systemStrategiesStatus === "loading"}
                type="system"
              />
            </li>
            <ActionButton
              label="Refresh"
              onClick={handleRefresh}
              icon={<LuRefreshCcw />}
              loading={signalStatus === "loading"}
              useAntdButton
            />
          </>
        )}
      </ActionButtonsWrapper>

      {showCreateStrategyModal && (
        <CreateStrategyModal
          show={showCreateStrategyModal}
          closeHandler={() => setShowCreateStrategyModal(false)}
          type={"create"}
        />
      )}
    </>
  );
}

export default InsightSignalOperations;
